import { Box, Tab, Tabs } from "@mui/material";
import { useIntl } from "react-intl";
import { Col, Row } from "reactstrap";
import { PartsUsedTableComponent } from "./PartsUsedTableComponent";
import { PartsRequestedTableComponent } from "./PartsRequestedTableComponent";
import PartNewRequestComponent from "./PartNewRequestComponent";
type AssistanceNavBarType = {
    mode: "workshop" | "backoffice";
    childrenColumnSize?: number;
    assistanceId: number;
    reload: boolean;
    setActiveTab: React.Dispatch<React.SetStateAction<number>>;
    activeTab: number;
    isComplete: boolean;
    isAcceptedBudget: boolean;
    assistanceStatus: string;
}

export function AssistancePartsNavBar({ mode, childrenColumnSize = 12, assistanceId, reload, setActiveTab, activeTab, isComplete, isAcceptedBudget, assistanceStatus }: AssistanceNavBarType) {

    const intl = useIntl();

    // Calculamos o offset da navbar porque queremos esconder opções
    // quando estamos em vistas diferentes 
    const navbarIndexOffset = mode === "backoffice" ? -1 : 0;

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };



    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                >
                    {/* Apenas mostramos a tab da informação se estiver no modo workshop */}
                    <Tab label={intl.formatMessage({ id: "Screens.Assistances.Parts.Navbar.PartsUsed" })} {...a11yProps(1 + navbarIndexOffset)} />
                    <Tab label={intl.formatMessage({ id: "Screens.Assistances.Parts.Navbar.PartsRequested" })} {...a11yProps(2 + navbarIndexOffset)} />
                    <Tab label={intl.formatMessage({ id: "Screens.Assistances.Parts.Navbar.PartsNewRequest" })} {...a11yProps(3 + navbarIndexOffset)} />
                </Tabs>
            </Box>
            <TabPanel
                value={activeTab}
                index={1 + navbarIndexOffset}
                childrenColumnSize={childrenColumnSize}
            >
                <PartsUsedTableComponent
                    mode={mode}
                    assistanceId={assistanceId}
                    reload={reload}
                    isComplete={isComplete}
                    isAcceptedBudget={isAcceptedBudget}
                    assistanceStatus= {assistanceStatus}
                />
            </TabPanel>
            <TabPanel
                value={activeTab}
                index={2 + navbarIndexOffset}
                childrenColumnSize={childrenColumnSize}
            >
                <PartsRequestedTableComponent
                    mode={mode}
                    assistanceId={assistanceId}
                    setActiveTab={setActiveTab}
                    reload={reload}
                    isComplete={isComplete}
                    isAcceptedBudget={isAcceptedBudget}
                />
            </TabPanel>
            <TabPanel
                value={activeTab}
                index={3 + navbarIndexOffset}
                childrenColumnSize={childrenColumnSize}
            >
                <PartNewRequestComponent
                    mode={mode}
                    assistanceId={assistanceId}
                    setActiveTab={setActiveTab}
                    reload={reload}
                    isComplete={isComplete}
                    isAcceptedBudget={isAcceptedBudget}
                />
            </TabPanel>
        </>
    )
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    childrenColumnSize: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, childrenColumnSize, ...other } = props;

    return (
        <Col xl={childrenColumnSize}>
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <>{children}</>
                )}
            </div>
        </Col>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}